var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "index-container border-box"
  }, [_c("a-row", {
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 15
    }
  }, [_c("a-card", {
    attrs: {
      title: "",
      hoverable: true,
      bordered: false
    }
  }, [_c("card-list", {
    on: {
      sendTitle: _vm.getTitle
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 9
    }
  }, [_c("a-card", {
    attrs: {
      title: "",
      hoverable: true,
      bordered: false
    }
  }, [_c("series-map", {
    staticStyle: {
      width: "100%",
      height: "350px"
    }
  })], 1)], 1)], 1), _c("a-row", {
    staticClass: "sale-list",
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 16
    }
  }, [_c("a-card", {
    attrs: {
      title: _vm.$t("消费种类占比"),
      hoverable: true,
      bordered: false
    }
  }, [_c("line-chart", {
    staticStyle: {
      height: "300px"
    },
    attrs: {
      chartData: _vm.lineData,
      title: _vm.currentName
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-card", {
    attrs: {
      title: _vm.$t("产品排行榜"),
      hoverable: true,
      bordered: false
    }
  }, [_c("shop-rank", {
    staticStyle: {
      height: "300px"
    },
    attrs: {
      rankData: _vm.rankData
    }
  })], 1)], 1)], 1), _c("a-row", {
    staticClass: "sale-list",
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-card", {
    attrs: {
      title: _vm.$t("产品统计图"),
      hoverable: true,
      bordered: false
    }
  }, [_c("pie-chart", {
    attrs: {
      chartData: _vm.pieData
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 16
    }
  }, [_c("a-card", {
    attrs: {
      title: _vm.$t("销售额 统计图"),
      hoverable: true,
      bordered: false
    }
  }, [_c("gradients-bar", {
    staticStyle: {
      width: "100%",
      height: "300px"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };